var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_53)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33334 6.66669C7.00725 6.66669 5.73548 7.19347 4.7978 8.13115C3.86012 9.06884 3.33334 10.3406 3.33334 11.6667V13.3334H36.6667V11.6667C36.6667 10.3406 36.1399 9.06884 35.2022 8.13115C34.2645 7.19347 32.9928 6.66669 31.6667 6.66669H8.33334ZM36.6667 16.6667H3.33334V28.3334C3.33334 29.6594 3.86012 30.9312 4.7978 31.8689C5.73548 32.8066 7.00725 33.3334 8.33334 33.3334H31.6667C32.9928 33.3334 34.2645 32.8066 35.2022 31.8689C36.1399 30.9312 36.6667 29.6594 36.6667 28.3334V16.6667ZM13.3333 25C13.3333 24.558 13.5089 24.1341 13.8215 23.8215C14.1341 23.5089 14.558 23.3334 15 23.3334H22.3567L22.155 23.1317C21.8423 22.8192 21.6665 22.3952 21.6663 21.9531C21.6662 21.511 21.8417 21.0869 22.1542 20.7742C22.4667 20.4615 22.8906 20.2857 23.3327 20.2855C23.7749 20.2854 24.1989 20.4608 24.5117 20.7734L27.5583 23.8217C27.8708 24.1342 28.0463 24.5581 28.0463 25C28.0463 25.442 27.8708 25.8658 27.5583 26.1784L24.5117 29.225C24.3579 29.3842 24.174 29.5112 23.9707 29.5985C23.7673 29.6859 23.5486 29.7318 23.3273 29.7338C23.106 29.7357 22.8866 29.6935 22.6817 29.6097C22.4769 29.5259 22.2908 29.4022 22.1343 29.2457C21.9779 29.0892 21.8541 28.9031 21.7703 28.6983C21.6865 28.4935 21.6443 28.274 21.6462 28.0527C21.6482 27.8314 21.6942 27.6127 21.7815 27.4093C21.8688 27.206 21.9958 27.0221 22.155 26.8684L22.3567 26.6667H15C14.558 26.6667 14.1341 26.4911 13.8215 26.1785C13.5089 25.866 13.3333 25.442 13.3333 25Z",
    fill: "#011165"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPay);
export default __webpack_public_path__ + "static/media/card_pay.24171f2918d1079549a5428f016578ee.svg";
export { ForwardRef as ReactComponent };